var render = function () {
  var _vm$eventData$name;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "EventList",
      "extra-items": [{
        text: (_vm$eventData$name = _vm.eventData.name) !== null && _vm$eventData$name !== void 0 ? _vm$eventData$name : '',
        to: 'EventView',
        params: _vm.$route.params.event_id
      }, '兌換序號清單']
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" 兌換碼清單 ")]), _c('b-input-group', {
    staticClass: "col-12 col-xl-4 mb-2"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋兌換碼、使用人"
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.fetchRedeemCodes
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2 col-12"
  }, [_vm._v("活動名稱：")]), _c('div', {
    staticClass: "col-lg-10 col-12"
  }, [_vm._v(_vm._s(_vm.eventData.name))])]), _c('div', {
    staticClass: "row mt-1"
  }, [_c('div', {
    staticClass: "col-lg-2 col-12"
  }, [_vm._v("活動代碼：")]), _c('div', {
    staticClass: "col-lg-10 col-12"
  }, [_vm._v(_vm._s(_vm.eventData.code))])]), _c('div', {
    staticClass: "row mt-1"
  }, [_c('div', {
    staticClass: "col-lg-2 col-12"
  }, [_vm._v("活動期間：")]), _c('div', {
    staticClass: "col-lg-10 col-12"
  }, [_vm._v(_vm._s(_vm.eventData.start_at) + " ~ " + _vm._s(_vm.eventData.end_at))])])])], 1), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.redeemCodes,
      "fields": _vm.fields
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    on: {
      "change": _vm.fetchRedeemCodes
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)])], 1)], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }